import type { GridColumnSettings } from '../grid-column.types';
import { RowActionsCellComponent } from './row-actions-cell.component';
import type { RowAction, RowActionButton, RowActionsCellParams } from './row-actions.types';

export function rowActionsColumn<TRow>(
    actions: readonly RowAction<TRow>[]
): GridColumnSettings<TRow> {
    return {
        flex: 0,
        width: 100,
        sortable: false,
        filter: false,
        cellRendererSelector: ({ data }) => {
            const buttons: RowActionButton[] = [];
            if (data !== undefined) {
                for (const action of actions) {
                    const link = action.getLink(data);
                    if (link !== null) {
                        buttons.push({ icon: action.icon, label: action.label, link });
                    }
                }
            }
            const params: RowActionsCellParams = { buttons };
            return { component: RowActionsCellComponent, params };
        },
    };
}
